import { render, staticRenderFns } from "./InventoryPage.vue?vue&type=template&id=2888f6c9&scoped=true&"
import script from "./InventoryPage.vue?vue&type=script&lang=js&"
export * from "./InventoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888f6c9",
  null
  
)

export default component.exports